import { fExecuteAPI } from "../../Server/Apis";

import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import moment from "moment";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  AttributePutAway,
  PutAwayHeadDetails,
  WMINV03BinGetRow,
} from "../../Server/ApiV2";
// item
export const GCToggleSearch_ItemName_Columns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "ItmCd", headerName: "ItmCd", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "NameFL", headerName: "NameFL", width: 90 },
  { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
  { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
  { field: "Model", headerName: "Model", width: 90 },
  { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
  { field: "BarCode", headerName: "BarCode", width: 90 },
];
export const GCToggleSearch_ItemName_Select_Arr = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

//customer
export const xGC_Toggle_Head_BinName_GridColumns = [
  { field: "id", headerName: "ID", width: 70, hide: true },
  { field: "UId", headerName: "Code", width: 90 },
  { field: "Name1", headerName: "Name1", width: 450 },
  { field: "BinAttr1", headerName: "BinAttr1", width: 450 },
  // { field: "Name1", headerName: "Name1", width: 220 },
];
export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];

export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_Itmcd: "",
  B_ItmName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_Packing: "", //Decimal
  B_BaseQty: "", //Decimal
};

export const sTrnTyp = "INV10R";

const GetItemFullSearchArr = async (xItemName, xLoc) => {
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI("SEARCHEXACTITEM_GETROW", FinalObj);
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull?.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull?.Type?.response?.data?.message
        ? vItemSearchFull?.Type?.response?.data?.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

const fItemCodeDependency = async (
  vItemSearchFull,
  setBufferObj,
  setUnit,
  defUnitValue = ""
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
    }));
    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);

    if (currentUnitArr.length > 0) {
      let vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === defUnitValue;
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: vItemUnitSet.Unit,
          B_UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
          B_Packing: vItemUnitSet.PackDesc,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: currentUnitArr[0].Unit,
          B_UnitName: currentUnitArr[0].Name1,
          B_PackQty: currentUnitArr[0].PackQty,
          B_Packing: currentUnitArr[0].PackDesc,
        }));
      }
    
    }
    setTimeout(() => {
      const element = document.querySelector('[tabindex="103"]');
      element.focus();
    }, 500);
    // document.getElementsByName("GC_Toggle_Head_BinName_Name")[0].focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch?.Type?.toUpperCase() === "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};
const fValidationHead_Client = (vRdxHead, vMediaQuery, fSummary) => {
  let iRes = true;
  if (
    vRdxHead.A_VocNo == "" ||
    vRdxHead.A_VocNo == null ||
    vRdxHead.A_VocNo == undefined
  ) {
    fAlertToast("FAILED", "Document Number should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_VocTyp == "" ||
    vRdxHead.A_VocTyp == null ||
    vRdxHead.A_VocTyp == undefined
  ) {
    fAlertToast("FAILED", "Document Type should not be empty");
    iRes = false;
  }
  if (
    vRdxHead.VocName == "" ||
    vRdxHead.VocName == null ||
    vRdxHead.VocName == undefined
  ) {
    fAlertToast("FAILED", "Document name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.PA_DocDt == "" ||
    vRdxHead.PA_DocDt == null ||
    vRdxHead.PA_DocDt == undefined ||
    vRdxHead.PA_DocDt == "Invalid Date"
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.UBAY == "" ||
    vRdxHead.UBAY == null ||
    vRdxHead.UBAY == undefined
  ) {
    fAlertToast("FAILED", "Unloading Bin code should not be empty");
    iRes = false;
  }
  if (
    vRdxHead.UBAYName == "" ||
    vRdxHead.UBAYName == null ||
    vRdxHead.UBAYName == undefined
  ) {
    fAlertToast("FAILED", "Unloading bin name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.A_Loc == "" ||
    vRdxHead.A_Loc == null ||
    vRdxHead.A_Loc == undefined
  ) {
    fAlertToast("FAILED", "Location should not be empty");
    iRes = false;
  }
  if (
    vRdxHead.LocName == "" ||
    vRdxHead.LocName == null ||
    vRdxHead.LocName == undefined
  ) {
    fAlertToast("FAILED", "Location name should not be empty");
    iRes = false;
  }

  if (
    vRdxHead.PA_Typ == "" ||
    vRdxHead.PA_Typ == null ||
    vRdxHead.PA_Typ == undefined
  ) {
    fAlertToast("FAILED", "Type should be Enter");
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj) => {
  let iRes = true;

  if (
    sBufferObj.B_Srno == "" ||
    sBufferObj.B_Srno == null ||
    sBufferObj.B_Srno == undefined
  ) {
    fAlertToast("FAILED", "Serial number should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_Itmcd == "" ||
    sBufferObj.B_Itmcd == null ||
    sBufferObj.B_Itmcd == undefined
  ) {
    fAlertToast("FAILED", "Item code should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_ItmName == "" ||
    sBufferObj.B_ItmName == null ||
    sBufferObj.B_ItmName == undefined
  ) {
    fAlertToast("FAILED", "Item name should not be empty");
    iRes = false;
  }

  if (
    sBufferObj.B_Qty == "" ||
    sBufferObj.B_Qty == null ||
    sBufferObj.B_Qty == undefined
  ) {
    fAlertToast("FAILED", "Qty should not be zero");
    iRes = false;
  }

  if (
    sBufferObj.B_Unit == "" ||
    sBufferObj.B_Unit == null ||
    sBufferObj.B_Unit == undefined
  ) {
    fAlertToast("FAILED", "Select unit");
    iRes = false;
  }
  if (
    sBufferObj.Bincode == "" ||
    sBufferObj.Bincode == null ||
    sBufferObj.Bincode == undefined
  ) {
    fAlertToast("FAILED", "Bincode should not be zero");
    iRes = false;
  }
  if (
    sBufferObj.B_BinName == "" ||
    sBufferObj.B_BinName == null ||
    sBufferObj.B_BinName == undefined
  ) {
    fAlertToast("FAILED", "BinName should not be zero");
    iRes = false;
  }

  return iRes;
};
//API SaveSIHead
const fSaveHead = async (fNewDetail, sBufferObj) => {
  let vSaveSIHeadObj = {};
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = {}; // await WmsPutAway_SaveDetail_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    //approve bool type false
    fNewDetail();
    fAlertToast("SUCCESS", "Successfully Saved");
  }
};
export const fApproveDetail = async (fNewDetail, dispatch) => {
  let vSaveSIHeadObj = {};
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);
  const vSaveSIHead = {}; //await WmsPutAway_ApproveDetail_GETROW(FinalObj);
  if (vSaveSIHead?.status === 200) {
    fAlertToast("SUCCESS", "Successfully posted");
    fNewDetail();
  }
};

const GetSIDetail = async (VocTyp, VocNo) => {
  let iSIDetailObj = {
    VocTyp,
    VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = {}; //await WmsPutAway_LoadDetail_GETROW(FinalObj);
  if (iSIDetailResult.status === 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      return iSIDetailResult?.data.ResultSet;
    } else {
      return [];
    }
  }
};
export const get_Fdisplay = async (VocTyp, VocNo) => {
  let iSIDetailObj = {
    VocTyp,
    VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await PutAwayHeadDetails(FinalObj);
  if (iSIDetailResult.status === 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      return iSIDetailResult?.data.ResultSet;
    } else {
      return [];
    }
  }
};
export const WMINV03_BinGetRow = async (VocTyp, VocNo) => {
  let iSIDetailObj = {
    VocTyp,
    VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await WMINV03BinGetRow(FinalObj);
  if (iSIDetailResult.status === 200) {
    if (iSIDetailResult?.data?.ResultSet?.length > 0) {
      return iSIDetailResult?.data.ResultSet;
    } else {
      return [];
    }
  }
};
const fLoad_Grid = async (VocTyp, VocNo, setDetailGridData) => {
  const iSIDetail = await GetSIDetail(VocTyp, VocNo);
  if (iSIDetail?.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
  } else {
    setDetailGridData([]);
  }
};

export const GetAttributes = async (setStatus) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vAttributeObj = {
    UserCd: vRdxUserInfoObj.UserID,
  };
  const iResp = await AttributePutAway(vAttributeObj);
  if (iResp?.status === 200) {
    setStatus(iResp?.data?.ResultSet);
    return iResp?.data?.ResultSet;
  } else {
    return [];
  }
};
export {
  GetItemFullSearchArr,
  GetUnitArr,
  fItemCodeDependency,
  GetSearchItem,
  fValidationDetail_Client,
  fValidationHead_Client,
  fLoad_Grid,
  fSaveHead,
};
